import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { atsPlansStyle as styles, atsplans as plans } from "../utils/atsPlans";
import "./atsplans.css";

import ATSModal from "../component/Ats/AtsModal";

const ATSPlans = () => {
  const navigate = useNavigate();
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [showAtsModal, setShowAtsModal] = useState(false);
  const [purchasePlan, setPurchasePlan] = useState({ billingCycle: "monthly" });

  const getPrice = (plan) => {
    return billingCycle === "monthly" ? plan.monthlyPrice : plan.yearlyPrice;
  };

  const getSavings = (plan) => {
    if (plan.name === "Starter") return "0";
    const monthlyCost = plan.monthlyPrice * 12;
    const yearlyCost = plan.yearlyPrice;
    const savings = Math.round(
      ((monthlyCost - yearlyCost) / monthlyCost) * 100
    );
    return savings;
  };

  async function handlePurchasePlan(plan) {
    try {
      setPurchasePlan({ ...plan, billingCycle: billingCycle });
      setShowAtsModal(true);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      {showAtsModal && (
        <ATSModal
          setShowAtsModal={setShowAtsModal}
          purchasePlan={purchasePlan}
        />
      )}
      <div id="section-ats-plans" style={styles.container}>
        <div style={styles.header}>
          <p
            style={{
              color: "#000",
              fontSize: "18px",
              marginBottom: "5px",
              position: "relative",
              width: "fit-content",
            }}
          >
            Plans & Pricing
            <span
              style={{
                position: "absolute",
                bottom: "0px",
                left: "0px",
                right: "0px",
                height: "2px",
                background:
                  "linear-gradient(to right, #006bff, #006bff 50%, #ff8000 50%)",
              }}
            ></span>
          </p>
          <h5 style={{ fontSize: "32px" }}>
            Choose the plan that works for you
          </h5>
          <p style={styles.subtitle}>
            Select the perfect plan for your needs. Upgrade or downgrade at any
            time.
          </p>
        </div>

        <div style={styles.billingToggle} className="billing_toggle">
          <div style={styles.toggleContainer}>
            <button
              style={{
                ...styles.toggleButton,
                ...(billingCycle === "monthly"
                  ? styles.toggleButtonActive
                  : {}),
              }}
              onClick={() => setBillingCycle("monthly")}
            >
              Monthly
            </button>
            <button
              style={{
                ...styles.toggleButton,
                ...(billingCycle === "yearly" ? styles.toggleButtonActive : {}),
              }}
              onClick={() => setBillingCycle("yearly")}
            >
              Yearly
            </button>
          </div>
          {billingCycle === "yearly" && (
            <div style={styles.badge}>Save up to 20%</div>
          )}
        </div>

        <div style={styles.plansGrid}>
          {plans.map((plan, index) => (
            <div
              key={plan.name}
              style={{
                ...styles.planCard,
                ...(plan.popular ? styles.planCardPopular : {}),
                ...(hoveredCard === index ? styles.planCardHover : {}),
              }}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              {plan.popular && (
                <div style={styles.popularBadge}>Most Popular</div>
              )}

              <h3
                style={{
                  ...styles.planName,
                  color: plan.popular ? "#000" : "#1f2937",
                }}
              >
                {plan.name}
              </h3>

              <p
                style={{
                  ...styles.planDescription,
                  color: plan.popular ? "#000" : "#6b7280",
                }}
              >
                {plan.description}
              </p>

              <div style={styles.priceContainer}>
                <div
                  style={{
                    ...styles.price,
                    color: plan.popular ? "#000" : "#1f2937",
                  }}
                >
                  <span style={styles.currency}>$</span>
                  {getPrice(plan)}
                  <span
                    style={{
                      ...styles.period,
                      color: plan.popular ? "#6b7280" : "#6b7280",
                    }}
                  >
                    /{billingCycle === "monthly" ? "mo" : "yr"}
                  </span>
                </div>
                {billingCycle === "yearly" && (
                  <div
                    style={{
                      ...styles.savings,
                      color: plan.popular ? "#22c55e" : "#22c55e",
                    }}
                  >
                    Save {getSavings(plan)}% annually
                  </div>
                )}
              </div>

              <ul style={styles.featuresList}>
                {plan.features.map((feature, featureIndex) => (
                  <li
                    key={featureIndex}
                    style={{
                      ...styles.featureItem,
                      color: plan.popular ? "rgba(0,0,0, 0.9)" : "#374151",
                      borderBottomColor: plan.popular
                        ? "rgba(0,0,0, 0.2)"
                        : "#f3f4f6",
                    }}
                  >
                    <div
                      style={{
                        ...styles.checkIcon,
                        backgroundColor: "#22c55e",
                        color: "#ffffff",
                      }}
                    >
                      ✓
                    </div>
                    {feature}
                  </li>
                ))}
              </ul>

              <div
                style={{
                  flex: "1",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  className="btn-plan-ats"
                  style={{
                    ...styles.ctaButton,
                    ...(plan.popular
                      ? {
                          backgroundColor: "#006bff",
                          color: "#ffffff",
                          border: "1px solid rgba(255, 255, 255, 0.3)",
                          backdropFilter: "blur(10px)",
                        }
                      : styles.secondaryButton),
                  }}
                  onClick={() => {
                    handlePurchasePlan(plan);
                  }}
                >
                  {plan.name === "Scale"
                    ? "Go Big"
                    : plan.name === "Growth"
                    ? "Upgrade & Grow"
                    : "Start for Free"}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ATSPlans;
